exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-container[data-v-427f8d8a]{text-align:center}.page-container .info[data-v-427f8d8a]{width:600px;border-radius:2px;background:#fff;text-align:center;position:absolute;left:50%;top:150px;margin-left:-340px;color:#333;-webkit-box-shadow:inset 0 0 10px #ccc;box-shadow:inset 0 0 10px #ccc}.page-container .info i[data-v-427f8d8a]{font-size:68px}.page-container .info h1[data-v-427f8d8a]{font-size:26px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-427f8d8a","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/404.vue
// module id = 535
// module chunks = 1